import { Values } from '@utils-global/type-values';
import { Pipe, PipeTransform } from '@angular/core';
import { ARRAY_ROLES, ENUM_ROLES } from '../../enums/enum-roles';
import { Nullable } from '@models-global/constants';
@Pipe({
  name: 'rolesPipe',
  standalone: false
})
export class RolesPipe implements PipeTransform {
  transform(roles: Nullable<Values<typeof ENUM_ROLES>[]>): string {
    if (!roles || !roles.length) {
      return '-';
    }
    return roles
      .map((role) => {
        const item = ARRAY_ROLES.find((r) => r.value === role);
        return item?.text ?? '[UNKNOWN ROLE]';
      })
      .join(', ');
  }
}
